import React from 'react';
import { GraduationCap, UserCheck, Check } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-12 md:py-16 px-4 bg-white" data-id="element-358">
      <div className="max-w-4xl mx-auto" data-id="element-359">
        {/* Title */}
        <div className="text-center mb-10" data-id="element-360">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900" data-id="element-361">
            Resultados que{' '}
            <span className="text-blue-600 underline decoration-blue-300 decoration-4 underline-offset-4" data-id="element-362">
              transforman
            </span>
          </h2>
        </div>

        {/* Two Column Cards */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-10" data-id="element-363">
          {/* Para tus Estudiantes */}
          <div className="bg-white rounded-2xl border-2 border-gray-200 p-6 md:p-8" data-id="element-364">
            <div className="flex items-center gap-3 mb-5" data-id="element-365">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-366">
                <GraduationCap className="w-5 h-5 text-blue-600" data-id="element-367" />
              </div>
              <h3 className="text-lg font-bold text-gray-900" data-id="element-368">
                Para tus Estudiantes
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-369">
              <li className="flex items-start gap-3" data-id="element-370">
                <Check className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-371" />
                <span className="text-gray-700" data-id="element-372">
                  Comprenden desde la práctica
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-373">
                <Check className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-374" />
                <span className="text-gray-700" data-id="element-375">
                  Conectan teoría y realidad
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-376">
                <Check className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-377" />
                <span className="text-gray-700" data-id="element-378">
                  Desarrollan pensamiento crítico
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-379">
                <Check className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-380" />
                <span className="text-gray-700" data-id="element-381">Participan más en clase</span>
              </li>
            </ul>
          </div>

          {/* Para Vos como Docente */}
          <div className="bg-white rounded-2xl border-2 border-gray-200 p-6 md:p-8" data-id="element-382">
            <div className="flex items-center gap-3 mb-5" data-id="element-383">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-384">
                <UserCheck className="w-5 h-5 text-orange-600" data-id="element-385" />
              </div>
              <h3 className="text-lg font-bold text-gray-900" data-id="element-386">
                Para Vos como Docente
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-387">
              <li className="flex items-start gap-3" data-id="element-388">
                <Check className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-389" />
                <span className="text-gray-700" data-id="element-390">
                  Ahorrás horas de planificación
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-391">
                <Check className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-392" />
                <span className="text-gray-700" data-id="element-393">Enseñás con claridad</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-394">
                <Check className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-395" />
                <span className="text-gray-700" data-id="element-396">Todo organizado</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-397">
                <Check className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-398" />
                <span className="text-gray-700" data-id="element-399">
                  Llegás sin estrés al cierre
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-400">
          <a href="#compra" className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white rounded-xl shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 transition-all px-10 py-4" data-id="element-401">
            <span className="font-bold text-lg" data-id="element-402">👉 QUIERO LOGRAR ESTO →</span>
          </a>
        </div>
      </div>
    </section>;
}